import { type Plugin, ref } from "vue";
import { useIsMobile } from "./composables/is-mobile.ts";
import "./globalExtensions.ts";
import { AppContextSymbol } from "./injectionSymbols.ts";
import { createLocale } from "./locale.ts";

export * from "./app-context.ts";
export * from "./components/data-collection/composables/data-collection.ts";
export * from "./components/index.ts";
export * from "./composables/is-mobile.ts";
export * from "./composables/screen-size.ts";
export * from "./composables/tooltip.ts";
export * from "./lib/base-props.ts";
export * from "./lib/command-score.ts";
export * from "./lib/css.ts";
export * from "./lib/placement.ts";
export * from "./lib/size.ts";
export * from "./lib/utils.ts";
export * from "./locale.ts";

export { Slot, useId } from "reka-ui";

import * as components from "./components/index.ts";

export type UIPluginOptions = {
	/** @deprecated */
	global?: boolean;
};

export function createUI(): Plugin<UIPluginOptions> {
	return {
		install(app, options) {
			if (options.global) {
				for (const [name, component] of Object.entries(components)) {
					if (name.startsWith("Soft")) {
						app.component(name, component as any);
					}
				}
			}

			createLocale(app);

			app.provide(AppContextSymbol, {
				dark: ref(false),
				isMobile: useIsMobile(),
			});
		},
	};
}

export const createSoftUI = createUI;
